import React, { ReactNode } from 'react';

import { CustomCardItem } from './CustomCard.styled';

export const CustomCard = ({
  border,
  borderRadius,
  padding,
  children,
  maxWidth,
  height,
}: {
  border?: string;
  borderRadius?: string;
  padding?: string;
  children?: ReactNode;
  maxWidth?: string;
  height?: string;
}) => {
  return (
    <CustomCardItem
      border={border}
      padding={padding}
      borderRadius={borderRadius}
      maxWidth={maxWidth}
      height={height}
    >
      {children}
    </CustomCardItem>
  );
};
